import { makeAutoObservable } from 'mobx';

// This store should be used for local state management of the accounts view
// this should not store or manipulate any data that is fetched from the API and should not be used
// beyond the accounts section of the app

export class AccountsStore {
  disableExternalComment = false;

  constructor() {
    makeAutoObservable(this);
  }

  toggleState(stateName: string, value: boolean) {
    switch (stateName) {
      case 'disableExternalComment':
        this.disableExternalComment = value;
        break;
      default:
        console.warn(`Unknown state name: ${stateName}`);
    }
  }
}
let accountsStore: AccountsStore | undefined;

export function getAccountsStore(): AccountsStore {
  if (!accountsStore) {
    accountsStore = new AccountsStore();
  }

  return accountsStore;
}
